import React,{Component} from 'react'
import {connect} from 'react-redux'
import {message } from 'antd';
import http from './../api/http'
import API from './../api/api'
import {saveUserInfo} from './../store/user/action.js'
import {view as Header} from './header/index'
import {view as Sidebar} from './sidebar/index'
import {view as Content} from './content/index'
import './style.less'

@connect(state=>({user:state.user}),{saveUserInfo})
class App extends Component{
    getUserInfo= async ()=>{
        if(!this.props.user.isLogin){
            let res=await http(API.GET_USER_INFO,'post');
            if(res.code===0){
                this.props.saveUserInfo({
                    userName:res.data.username,
                    userId:res.data.user_id,
                    isLogin:true,
                });
            }else{
                message.error(res.message);
            }
        }
    }
    componentDidMount(){
        this.getUserInfo();
    }
    render(){
        return (
            <div style={{display:'flex',flexDirection:'column',height:'100%',minWidth:'1200px'}}>
                <Header className="header" />
                <div style={{display:'flex',flex:1}}>
                    <div style={{width:'200px'}}>
                        <Sidebar />
                    </div>
                    <div id="content" style={{flex:1,overflowY:'scroll',backgroundColor:'#EFF1F6'}}>
                        <Content />
                    </div>
                </div>
            </div> 
        )
    }
}
export default App;


// WEBPACK FOOTER //
// ./src/app/view.js